import { Component, OnInit, OnDestroy } from '@angular/core';
import { Category } from 'src/app/models/category.model';
import { ReferenceSearchParams } from 'src/app/models/reference-search-params';
import { AppService } from 'src/app/app.service';
import { SearchResult, Result } from 'src/app/models/search-result';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

  categories: Array<Category> = [];
  cat$ = null;
  searching = false;
  error: any;
  lang$: any;
  lang = null;

  searchParams: ReferenceSearchParams = new ReferenceSearchParams();
  result: SearchResult = null;

  constructor(
    private appService: AppService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.cat$ = this.appService.categories.subscribe((c) => {
      this.categories = c;
    });
    this.lang$ = this.appService.selectedLang.subscribe((l) => {
      if (l) {
        this.lang = l;
        this.searchParams.languageCode = l;
      } else {
        this.searchParams.languageCode = this.translate.currentLang;
      }
      this.onSearch();
    });
  }

  ngOnDestroy() {
    this.cat$.unsubscribe();
    this.lang$.unsubscribe();
  }

  onSearch() {
    this.searching = true;
    this.appService.searchReference(this.searchParams).subscribe(
      (result) => {
        this.searching = false;
        this.result = result;
      },
      (error) => {
        this.error = error;
        this.searching = false;
      }
    );
  }

  onSearchParamsChange() {
    this.onSearch();
  }

  onEdit(reference: Result) {
    this.router.navigateByUrl('/references/form/' + reference.referenceDocumentId);
  }

  onDelete(reference: Result) {
    this.appService.deleteReference(reference.referenceDocumentId).subscribe(
      () => {
        this.result.result.splice(this.result.result.indexOf(reference), 1);
      }
    );
  }

  onExport(type: string) {
    // do (type: pdf, excel)
    this.result.result.forEach((r) => {
      if (r.selected) {
        this.appService.getExport(r.referenceDocumentId, type).subscribe(
          (res) => {
            // console.log(res)
            let blob;
            if (type === 'word') {
              blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            }
            if (type === 'pdf') {
              blob = new Blob([res], { type: 'application/pdf' });
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            if (type === 'word') {
              a.download = 'reference_' + r.referenceDocumentId + '.docx';
            }
            if (type === 'pdf') {
              a.download = 'reference_' + r.referenceDocumentId + '.pdf';
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
          }
        );
      }
    });
  }

  returnSelectedResults() {
    if (!this.result) { return []; }
    return this.result.result.filter((el) => {
      return el.selected;
    });
  }

  getSelectedAmount() {
    return this.result.result.filter(r => r.selected).length;
  }

  onDeleteMarked() {
    if (window.confirm('Sind Sie sicher, dass Sie ' + this.getSelectedAmount() + ' Referenzen löschen möchten?')) {
      this.result.result.forEach((r) => {
        if (r.selected) {
          this.onDelete(r);
        }
      });
    }
  }

}
